<template>
  <v-container fluid class="theme-color" style="height: 100%;">
    <Search
      class="dialog mb-3"
      :class="{ xs: $vuetify.breakpoint.xsOnly }"
      :defaultDatefrommap="DefaultDateFromMap"
      :departmentMultiple="true"
      @getSearchCondition="updateCondition"
    />
    <List
      class="dialog"
      :class="{ xs: $vuetify.breakpoint.xsOnly }"
      :searchCondition="condition"
      :allowUpload="userPermission.is_allow_upload"
      :roleDepartment="userRole"
      @setDefaultDateFromMap="setDefaultDateFromMap"
    />
  </v-container>
</template>

<script>
import Search from '../components/report/Search.vue';
import List from '../components/report/List.vue';

export default {
  name: 'Report',
  components: {
    Search,
    List
  },
  props: {
    userPermission: {
      type: Object
    },
    userRole: {
      type: String
    }
  },
  data: () => ({
    condition: null,
    DefaultDateFromMap: {}
  }),
  mounted() {},
  methods: {
    updateCondition(value) {
      this.condition = value;
    },
    setDefaultDateFromMap(value) {
      this.DefaultDateFromMap = value;
    }
  }
};
</script>

<style lang="scss" scoped></style>
